import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-admission-detail',
  templateUrl: './admission-detail.component.html',
  styleUrls: ['./admission-detail.component.css']
})
export class AdmissionDetailComponent implements OnInit {
  datas:any;
  textafficher=""
  constructor(private route:ActivatedRoute) {
    this.datas = this.route.snapshot.params['data'];
    this.route.queryParams.subscribe(params => {
      this.datas = params.data;
    }
    )

    if (this.datas == 'InformatiqueReseauxIndustriel') {
      this.textafficher = "Licence en Informatique et Réseaux Industriels";
    }else if(this.datas == 'GENIE-BIOLOGIQUE'){
      this.textafficher = "LICENCE DE GENIE BIOLOGIQUE";
    }
    else if(this.datas == 'LICENCE-STATISTIQUE-INFORMATIQUE-DECISIONNELLE'){
      this.textafficher = "LICENCE EN STATISTIQUE ET INFORMATIQUE DÉCISIONNELLE";
    }
    else if(this.datas == 'INFIRMIER'){
      this.textafficher = "INFIRMIERS D’ETAT";
    }
    else if(this.datas == 'SAGES-FEMMES'){
      this.textafficher = "SAGES FEMMES D’ETAT";
    }
    else if(this.datas == 'GestionAdministrationBien'){
      this.textafficher = 'Licence Gestion et Administration des Biens'
    }
    
   }

  ngOnInit(): void {
  }

}
